import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const DownloadDraggable = () => {
  const id = v4()
  const type = FormItemType.Upload

  return (
    <FormItemDraggableBase
      icon={IconEnum.Download}
      id={id}
      title="formBuilder.download"
      type={type}
    />
  )
}
